<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <input
                            type="search"
                            placeholder="Search products"
                            v-model="search"
                            class="form-control"
                        >
                        <span v-if="loading">
                            Loading... <i class="fa fa-spinner fa-spin" />
                        </span>
                        <span v-if="loaded && products.length === 0">
                            No products yet, try adding some.
                        </span>
                    </div>
                    <div class="col-sm-12 col-md-6 text-right">
                        <router-link
                            class="btn btn-info"
                            :to="{name: 'product-categories'}"
                        >
                            Product Categories
                        </router-link>
                        <router-link
                            class="btn btn-primary"
                            :to="{name: 'products.new'}"
                        >
                            <i class="fa fa-plus" />Add Product
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table
                            v-if="loaded && products.length"
                            class="table products-table"
                        >
                            <thead>
                                <tr>
                                    <th>Photo</th>
                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>Unit Price</th>
                                    <th>Category</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="product in filteredProducts"
                                    :key="product.id"
                                    @click="goToProduct(product.id)"
                                >
                                    <td>
                                        <img
                                            v-if="product.photo_url"
                                            :src="product.photo_url"
                                            :alt="product.name"
                                        >
                                        <span v-else>No Photo</span>
                                    </td>
                                    <td>{{ product.name }}</td>
                                    <td>{{ product.code }}</td>
                                    <td>£{{ product.unit_price }}</td>
                                    <td>
                                        <span v-if="product.category">{{ product.category.name }}</span>
                                    </td>
                                    <td />
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProductsService from '../../../services/ProductsService';
import UsesErrors from '../../../mixins/UsesErrors';

export default {
    mixins: [UsesErrors],

    data () {
        return {
            products: [],
            loading: false,
            loaded: false,
            search: '',
        };
    },

    computed: {
        filteredProducts() {
            if (!this.search) {
                return this.products;
            }

            return this.products.filter(p => {
                if (p.name.toLowerCase().includes(this.search.toLowerCase())) {
                    return true;
                }
                if (p.code && p.code.toLowerCase().includes(this.search.toLowerCase())) {
                    return true;
                }

                return false;
            });
        },
    },

    mounted () {
        this.loadProducts();
    },
    
    methods: {
        loadProducts () {
            this.loading = true;
            ProductsService.index().then(res => {
                this.products = res.data;
                this.loaded = true;
            }).catch(err => {
                this.showErrorMessage('Error: Failed to load products');
                this.products = [];
                throw err;
            }).then(() => {
                this.loading = false;
            })
        },

        goToProduct (id) {
            this.$router.push({name: 'products.edit', params: {id}});
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/products/IndexComponent.vue